import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery } from "@tanstack/react-query";
import getApiCosts from "../http/getApiCosts";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

// Platform-wide AI/API spend over a window, across every surface that records
// into the shared cost ledger. Admin-only (inrange-org gated).
export const useApiCosts = (
  days: number,
  source?: string | null,
  enabled = true
) => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);
  return useQuery(
    ["apiCosts", days, source ?? null],
    async () =>
      getApiCosts(
        await getAuthTokenBlocking(getToken, relogin),
        days,
        source ?? null
      ),
    { enabled }
  );
};

export default useApiCosts;
